import React, { useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import { collection, addDoc, doc, setDoc } from "firebase/firestore";
import { db } from "../Firebase Functions/firebase";
import "../TruckServices/ChecklistForm.css";
import UploadPayrollDeductionToQuickBase from "../Quickbase Functions/UploadPayrollDeductiontoQB";

function PayrollDeductionForm() {
  const location = useLocation();
  const incidentId = location.state?.incidentId || null;

  const [formData, setFormData] = useState({
    company: "Rotolo Consultants, Inc.",
    totalAmount: "",
    deductions: {
      loan: { enabled: false, value: "" },
      k401: { enabled: false, value: "" },
      advance: { enabled: false, value: "" },
      insurance: { enabled: false, value: "" },
      uniforms: { enabled: false, value: "" },
      rent: { enabled: false, value: "" },
      other: { enabled: false, value: "" },
    },
    frequency: {
      oneTime: false,
      weekly: false,
      customAmount: "",
      customWeeks: "",
      other: "",
    },
    employeeName: "",
    payId: "",
    supervisor: "",
    project: "",
    date: "",
    signature: "",
  });

  const signatureRef = useRef();

  const updateField = (section, field, value) => {
    setFormData(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      }
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  const sigData = signatureRef.current?.getTrimmedCanvas().toDataURL("image/png");
  if (!sigData) {
    alert("Signature is required.");
    return;
  }

  const incomplete = Object.entries(formData.deductions).some(
    ([, item]) => item.enabled && item.value.trim() === ""
  );

  if (incomplete) {
    alert("Please complete all selected deduction items.");
    return;
  }

  const completeForm = {
    ...formData,
    incidentId,
    signature: sigData,
    submittedAt: new Date().toISOString(),
  };

  try {
    // Step 1: Save to Firestore (wait for confirmation)
    const docRef = doc(db, "payrollDeductions", incidentId);
    await setDoc(docRef, completeForm);

    console.log("✅ Firestore write confirmed.");

    // Optional: Show success alert here if you want
    alert("Payroll Deduction form saved. Uploading to QuickBase...");

    // Step 2: Upload PDF to QuickBase
    await UploadPayrollDeductionToQuickBase(incidentId);
    console.log("✅ QuickBase update completed.");

  } catch (error) {
    console.error("Error during submission:", error);
    alert("Submission failed. Please try again.");
  }
};



  return (
    <form className="checklist-form" onSubmit={handleSubmit} noValidate>
      <h1 className="form-title">Payroll Deduction Authorization</h1>

      <div className="form-group">
        <label>Company</label>
        <input type="text" value={formData.company} readOnly className="form-control" />
      </div>

      <div className="form-group">
        <label>Total Deduction Amount ($)</label>
        <input
          type="number"
          value={formData.totalAmount}
          onChange={e => setFormData({ ...formData, totalAmount: e.target.value })}
          className="form-control"
        />
      </div>

      <h2 className="section-title">Deduction Items</h2>
      {Object.entries(formData.deductions).map(([key, item]) => (
        <div className="form-group" key={key}>
          <label style={{ display: "flex", alignItems: "center" }}>
            <input
              type="checkbox"
              checked={item.enabled}
              onChange={(e) =>
                setFormData(prev => ({
                  ...prev,
                  deductions: {
                    ...prev.deductions,
                    [key]: {
                      ...prev.deductions[key],
                      enabled: e.target.checked
                    }
                  }
                }))
              }
              style={{ marginRight: "10px" }}
            />
            {key.charAt(0).toUpperCase() + key.slice(1)}
          </label>
          {item.enabled && (
            <input
              type="text"
              placeholder="Enter detail"
              value={item.value}
              onChange={(e) =>
                setFormData(prev => ({
                  ...prev,
                  deductions: {
                    ...prev.deductions,
                    [key]: {
                      ...prev.deductions[key],
                      value: e.target.value
                    }
                  }
                }))
              }
              className="form-control"
            />
          )}
        </div>
      ))}

      <h2 className="section-title">Deduction Frequency</h2>
      <div className="form-group">
        <label>
          <input
            type="checkbox"
            checked={formData.frequency.oneTime}
            onChange={(e) => updateField("frequency", "oneTime", e.target.checked)}
          /> One Time Only
        </label>
      </div>

      <div className="form-group">
        <label>
          <input
            type="checkbox"
            checked={formData.frequency.weekly}
            onChange={(e) => updateField("frequency", "weekly", e.target.checked)}
          /> Weekly
        </label>
      </div>

      <div className="form-group">
        <label>Custom Weekly Deduction</label>
        <input
          type="text"
          placeholder="$ per week"
          value={formData.frequency.customAmount}
          onChange={(e) => updateField("frequency", "customAmount", e.target.value)}
          className="form-control"
        />
        <input
          type="number"
          placeholder="# weeks"
          value={formData.frequency.customWeeks}
          onChange={(e) => updateField("frequency", "customWeeks", e.target.value)}
          className="form-control"
        />
      </div>

      <div className="form-group">
        <label>Other</label>
        <input
          type="text"
          value={formData.frequency.other}
          onChange={(e) => updateField("frequency", "other", e.target.value)}
          className="form-control"
        />
      </div>

      <h2 className="section-title">Employee Details</h2>
      <div className="form-group">
        <label>Employee Name</label>
        <input
          type="text"
          value={formData.employeeName}
          onChange={e => setFormData({ ...formData, employeeName: e.target.value })}
          className="form-control"
        />
      </div>

      <div className="form-group">
        <label>Pay ID</label>
        <input
          type="text"
          value={formData.payId}
          onChange={e => setFormData({ ...formData, payId: e.target.value })}
          className="form-control"
        />
      </div>

      <div className="form-group">
        <label>Supervisor</label>
        <input
          type="text"
          value={formData.supervisor}
          onChange={e => setFormData({ ...formData, supervisor: e.target.value })}
          className="form-control"
        />
      </div>

      <div className="form-group">
        <label>Project Name and Number</label>
        <input
          type="text"
          value={formData.project}
          onChange={e => setFormData({ ...formData, project: e.target.value })}
          className="form-control"
        />
      </div>

      <div className="form-group">
        <label>Date</label>
        <input
          type="date"
          value={formData.date}
          onChange={e => setFormData({ ...formData, date: e.target.value })}
          className="form-control"
        />
      </div>

      <h2 className="section-title">Signature</h2>
      <div className="signature-container">
        <SignatureCanvas
          ref={signatureRef}
          penColor="black"
          canvasProps={{
            className: "signature-canvas",
            style: { border: "1px dashed #ccc", width: "100%", height: "150px" }
          }}
        />
        <p className="signature-hint">Sign within the box</p>
        <button type="button" onClick={() => signatureRef.current.clear()} className="clear-button">
          Clear Signature
        </button>
      </div>

      <button type="submit" className="submit-button">Submit Authorization</button>
    </form>
  );
}

export default PayrollDeductionForm;
